export enum AddressTypeEnum {
    Residential = 1,
    Correspondence = 2,
    Registered = 3
}
